export const ROUTES = {
  HOME: "/home",
  HOME_PROCESS_RUNS: "/home/process-runs",
  HOME_PROCESS_RUNS_DETAIL: (id: string) =>
    `/home/process-runs/${encodeURIComponent(id)}`,
} as const;
